import type { ExecutorchEmbeddingService } from "$src/core/services/search-classification/types";

const ExecutorchEmbedding: ExecutorchEmbeddingService = {
  status: "unavailable",
  classify: async () => null,
  startDownload: async () => undefined,
  getDownload: async () => "missing",
  deleteDownload: async () => undefined,
  addDownloadProgressListener: () => () => undefined,
};

export default ExecutorchEmbedding;
